import { ZodType, z } from 'zod';

import { AuthForgotPasswordDto } from '../../libs/types';

export const ForgotPasswordSchema: ZodType<AuthForgotPasswordDto> = z.object({
  email: z
    .string({ required_error: '이메일을 입력해주세요.' })
    .min(1, '이메일을 입력해주세요.')
    .email('이메일 형식이 올바르지 않습니다.'),
  referrer: z.string(),
});
